import { Button } from 'devextreme-react/button';
import { Column, ColumnFixing, DataGrid, Editing, FilterRow, Item, Pager, Paging, SearchPanel, Toolbar } from 'devextreme-react/data-grid';
import moment from 'moment';
import React, { useRef, useState } from 'react';
import { ButtonOnExporting } from '../../utils/DataGridExporter';

const TasimaListesi = ({ allTasimalar, isLoading, dateRange, handleFilter, exportToExcel, handleDelete, getAllTasimalar }) => {
    const [isDeleting, setIsDeleting] = useState(false);
    const dataGridRef = useRef(null);

    const handleDeleteWithRefresh = async (id) => {
        try {
            setIsDeleting(true);
            await handleDelete(id);
            await getAllTasimalar();
        } catch (error) {
            console.error("Silme işlemi sırasında hata oluştu:", error);
        } finally {
            setIsDeleting(false);
        }
    };

    const handleRefresh = async () => {
        try {
            await handleFilter();
        } catch (error) {
            console.error("Yenileme işlemi sırasında hata oluştu:", error);
        }
    };

    const commonSettings = {
        showClearButton: true,
        openOnFieldClick: false,
        startLabel: "Başlangıç Tarihi",
        endLabel: "Bitiş Tarihi",
        startDateLabel: "Başlangıç Tarihi",
        endDateLabel: "Bitiş Tarihi",
    };

    return (
        <>
            <DataGrid
                dataSource={allTasimalar}
                showBorders={true}
                columnAutoWidth={true}
                columnResizingMode="widget"
                allowColumnReordering={true}
                height={650}
                rowAlternationEnabled={true}
                showColumnLines={true}
                showRowLines={true}
                allowColumnResizing={true}
                ref={dataGridRef}
                noDataText="Veri bulunamadı"
                loadPanel={{
                    enabled: isLoading || isDeleting,
                    showPane: true,
                    showIndicator: true,
                    shading: true,
                    shadingColor: 'rgba(0,0,0,0.4)',
                    text: isLoading ? "Yükleniyor..." : "Siliniyor..."
                }}
                onRowRemoved={(e) => {
                    console.log("Row removed: ", e.data);
                    handleDeleteWithRefresh(e.data.id);
                }}
            >
                <Editing
                    mode="row"
                    allowDeleting={true}
                    confirmDelete={true}
                    useIcons={true}
                    texts={{
                        confirmDeleteMessage: "Bu kaydı silmek istediğinizden emin misiniz?"
                    }}

                />
                <ColumnFixing enabled={true}
                    texts={{
                        leftPosition: "Sol'a Sabitle",
                        rightPosition: "Sağ'a Sabitle"
                    }}
                />

                <SearchPanel visible={true} width={240} placeholder="Ara..." />
                <FilterRow visible={true} />
                <Pager enabled={true} allowedPageSizes={[25, 50, 100]} showPageSizeSelector={true} />
                <Paging defaultPageSize={25} />
                <Toolbar>
                    <Item location="after" name="searchPanel" />
                    <Item name="addRowButton" />
                    <Item name="saveButton" />
                    <Item location="after">
                        <Button
                            text="Excel'e Aktar"
                            type="success"
                            stylingMode="contained"
                            icon="exportxlsx"
                            onClick={(e) => ButtonOnExporting(e, dataGridRef, "Özel Tasimalar" + moment().format("DD/MM/YYYY HH:mm:ss"), "Sayfa-1")}
                            disabled={isLoading || allTasimalar.length === 0}
                        />
                    </Item>
                    <Item location="after">
                        <Button
                            type="default"
                            stylingMode="text"
                            icon="refresh"
                            onClick={handleRefresh}
                            disabled={isLoading || isDeleting}
                            hint="Yenile"
                        />
                    </Item>
                </Toolbar>

                <Column
                    dataField="shipment_type"
                    width={120}
                    caption='Sevkiyat Türü'
                    headerCellRender={() => (
                        <div style={{ whiteSpace: 'normal', lineHeight: '1.5', textAlign: 'left', padding: '5px', height: '40px', display: 'flex', alignItems: 'center' }}>
                            Sevkiyat<br />Türü
                        </div>
                    )}
                />
                <Column
                    dataField="shipment_date"
                    width={90}
                    caption='Sevk Tarihi'
                    headerCellRender={() => (
                        <div style={{ whiteSpace: 'normal', lineHeight: '1.5', textAlign: 'left', padding: '5px', height: '40px', display: 'flex', alignItems: 'center' }}>
                            Sevk<br />Tarihi
                        </div>
                    )}
                    dataType="date"
                    format="dd.MM.yyyy"
                />
                <Column dataField="chassis_no" caption="Şase" width={155} />
                <Column dataField="brand" caption="Marka" width={80} />
                <Column
                    dataField="model"
                    width={80}
                    caption='Model'
                    headerCellRender={() => (
                        <div style={{ whiteSpace: 'normal', lineHeight: '1.5', textAlign: 'left', padding: '5px', height: '40px', display: 'flex', alignItems: 'center' }}>
                            Model <br /> (kısa)
                        </div>
                    )}
                />
                <Column dataField="from_location" caption="Nereden" width={130} />
                <Column dataField="to_location" caption="Nereye" width={100} />
                <Column
                    dataField="requester"
                    width={120}
                    caption='Talep Eden'
                    headerCellRender={() => (
                        <div style={{ whiteSpace: 'normal', lineHeight: '1.5', textAlign: 'left', padding: '5px', height: '40px', display: 'flex', alignItems: 'center' }}>
                            Talep<br />Eden
                        </div>
                    )}
                />
                <Column
                    dataField="transport_company"
                    width={120}
                    caption='Taşıyıcı Firma'
                    headerCellRender={() => (
                        <div style={{ whiteSpace: 'normal', lineHeight: '1.5', textAlign: 'left', padding: '5px', height: '40px', display: 'flex', alignItems: 'center' }}>
                            Taşıyıcı<br />Firma
                        </div>
                    )}
                />
                <Column
                    dataField="client_price"
                    width={120}
                    caption='Müşteriye Fatura Edilecek Tutar (KDV Hariç)'
                    headerCellRender={() => (
                        <div style={{ whiteSpace: 'normal', lineHeight: '1.2', textAlign: 'left', padding: '5px', height: '62px', display: 'flex', alignItems: 'center' }}>
                            Müşteriye<br />Fatura Edilecek Tutar <br />
                            (KDV Hariç)
                        </div>
                    )}
                    dataType="number"
                    format="#,##0.##"
                    alignment="right"
                />
                <Column
                    dataField="transport_price"
                    width={110}
                    caption='Nakliyeciye Ödenecek Tutar (KDV Hariç)'
                    headerCellRender={() => (
                        <div style={{ whiteSpace: 'normal', lineHeight: '1.2', textAlign: 'left', padding: '5px', height: '62px', display: 'flex', alignItems: 'center' }}>
                            Nakliyeciye<br />Ödenecek Tutar <br />
                            (KDV Hariç)
                        </div>
                    )}
                    dataType="number"
                    format="#,##0.##"
                    alignment="right"
                />

                <Column
                    dataField="shipment_reason"
                    minWidth={80}
                    caption='Sevk Sebebi'
                    headerCellRender={() => (
                        <div style={{ whiteSpace: 'normal', lineHeight: '1.5', textAlign: 'left', padding: '5px', height: '40px', display: 'flex', alignItems: 'center' }}>
                            Sevk<br />Sebebi
                        </div>
                    )}
                />
                <Column dataField="create_user" caption="Kullanıcı" width={110} />
                <Column type='buttons' width={55} fixed={false} />

            </DataGrid >
        </>
    );
};

export default TasimaListesi; 